
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import TerminalData, { TerminalDataRequired } from "./TerminalData";
import { mapGetters } from "vuex";

export default {
  name: "app-terminal-form",
  props: {
    url: {
      type: String,
    },
    terminal: {
      type: Object,
      default: () => {},
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: new TerminalData({}),
    };
  },
  validations: {
    form: TerminalDataRequired,
  },
  watch: {
    terminal(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_terminal"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, this.form);
        this.$router.push({ name: "terminais" });
      } catch {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
